<template>
  <div class="container py-5">
    <div class="row">
      <div class="col">
        <a class="back-button" href="/dashboard" style="position: relative;">
          <img v-bind:src="'/images/arrow_back_blue.svg'" alt style="margin: 0 4px 4px 0;"/> Back to Dashboard
        </a>
      </div>
    </div>

    <div class="row" style="margin-bottom: 40px;">
      <div class="col">
        <div class="page-title">Directory</div>
        <div class="page-desc">Access your company directory with just one click.</div>
      </div>
    </div>

    <div class="row" v-if="user">
      <div class="col-12 col-md-8 offset-md-2">
        <div class="row mb-5">
          <div class="col-12 col-md-3">
            <user-avatar :avatarURL="user.avatar_src" size="134"></user-avatar>
          </div>
          <div class="col-12 col-md-9 d-flex flex-column justify-content-center text-center text-md-left">
            <div class="user-name">{{ user.name }}</div>
            <div class="join-date">Member since {{ userJoinDate }}</div>
            <a class="btn wfh-btn-primary-outline mt-3" href="/profile" v-if="isCurrentUser">Edit Profile</a>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="subheader">About {{ userName }}</div>
          </div>
        </div>

        <div class="row mb-5">
          <div class="col py-4" style="border-bottom: solid 1px #d5d5d5;">
            <div class="row">
              <div class="col-12 col-md-6 mb-3">
                <div class="label">Email Address</div>
                <a class="value" :href="`mailto:${user.email}`">{{ user.email }}</a>
              </div>
              <div class="col-12 col-md-6 mb-3">
                <div class="label">Contact Number</div>
                <a class="value" :href="`tel:${phoneNumberText}`" v-if="user.phone_number">{{ phoneNumberText }}</a>
                <div class="value" v-else>{{ phoneNumberText }}</div>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 mb-3">
                <div class="label">Location</div>
                <div class="value" v-if="userLocation">{{ userLocation }}</div>
                <div class="value" v-else>NIL</div>
              </div>

              <div class="col-12 col-md-6 mb-3" v-for="socialMedia in user.socialMedias">
                <div class="label">{{ socialMedia.name }}</div>
                <a class="value" :href="socialMedia.pivot.link">{{ socialMedia.pivot.link }}</a>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col">
            <div class="subheader">Organization</div>
          </div>
        </div>

        <div class="row">
          <div class="col py-4">
            <div class="row mb-4">
              <div class="col-12 col-md-6">
                <div class="label">Position</div>
                <div class="value">{{ user.designation }}</div>
              </div>
              <div class="col-12 col-md-6">
                <div class="label">Team</div>
                <div class="value">{{ userTeamsText }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  data () {
    return {
      user: null,
    };
  },

  computed: {
    currentUser () {
      return this.$store.state.currentUser;
    },

    userName () {
      return this.user.display_name ?? this.user.name;
    },

    userLocation () {
      if (this.user?.office_timezone) {
        const offices = this.user.company.offices;
        const officeTimezone = this.user.office_timezone;

        const currentLocation = offices.filter(function (office) {
          return office.zone_name === officeTimezone.zone_name;
        })[0];

        return currentLocation.text;
      }
    },

    phoneNumberText () {
      return this.user.phone_number ? `+${this.user.country_calling_code}${this.user.phone_number}` : 'NIL';
    },

    userTeamsText () {
      const teams = this.user.groups.map(function (group) {
        return group.name;
      });

      return teams.join(', ');
    },

    userJoinDate () {
      return moment(this.user.created_at).format('D MMMM YYYY');
    },

    isCurrentUser () {
      return this.currentUser?.id === this.user?.id;
    },
  },

  methods: {
    async getUserData (userId) {
      this.user = await axios.get(`/users/${userId}`).then(res => res.data.data);
    },
  },

  mounted () {
    const urlParams = new URLSearchParams(window.location.search);
    this.getUserData(urlParams.get('uid'));
  },
};
</script>

<style scoped lang="scss">
.page-title {
  color: #303030;
  font-family: Lato;
  font-size: 38px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 53.2px;
  text-align: center;
}

.page-desc {
  color: #606064;
  font-family: "Open Sans", sans-serif;
  font-size: 20px;
  letter-spacing: 0;
  line-height: 28px;
  text-align: center;
}

.label {
  color: #808fa4;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.5px;
  line-height: 22px;
}

.value {
  font-family: "Open Sans", sans-serif;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 28px;

  div {
    color: #515151;
  }
}

.user-name {
  color: #333;
  font-family: "Open Sans", sans-serif;
  font-size: 32px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 43px;
}

.join-date {
  color: #8392a6;
  font-family: "Open Sans", sans-serif;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
}

.subheader {
  color: #222227;
  font-family: Lato;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 24px;
}

@media (min-width: 768px) {
  .wfh-btn-primary-outline {
    max-width: 200px;
  }
}
</style>
